/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-children-prop */
import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  List,
  ListItem,
  ListItemText,
  Modal,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useStyles from '../../../../assets/styles/pages/Address';
import Header from '../../../../components/Header';

// import svg
import { ReactComponent as IconSave } from '../../../../assets/images/svg/address_create/icon_salvar.svg';
import { ReactComponent as IconInfo } from '../../../../assets/images/svg/utils/info.svg';

import FooterMenuMain from '../../../../components/FooterMenuMain';
import { useLoadingContext } from '../../../../providers/use-loading';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { api } from '../../../../services';
import { useSignInContext } from '../../../../providers/use-signin';
import { getStorege, saveStorege } from '../../../../helpers/db_storage';

const styleModal = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  p: 4,
  outline: 'none',
};

const styleModalInfo = {
  position: 'absolute' as const,
  top: '100%',
  height: 850,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: 4,
  outline: 'none',
};

const Address: React.FC = () => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();
  const { params, id_shop }: any = useParams();
  const navigate = useNavigate();
  const signData = useSignInContext();
  const { search } = useLocation();
  const variavelGet = new URLSearchParams(search);
  const getUser = variavelGet.get('user');

  const [openModalSelectStateCity, setOpenModalSelectStateCity] =
    useState(false);
  const [openModalSelectDistrict, setOpenModalSelectDistrict] = useState(false);
  const [errorInfo, setErrorInfo] = useState('');
  const [openModalErrorInfo, setOpenModalErrorInfo] = useState(false);
  const [stateList, setStateList] = useState<any>();
  const [stateSelected, setStateSelected] = useState<number>(0);
  const [cityList, setCityList] = useState<any>();
  const [destrictList, setDestrictList] = useState<any>();
  const [dataAddress, setDataAddress] = useState<any>({
    nr_operacao: 11,
    idUsuario: 0,
    idCidade: 0,
    dsCidade: '',
    nrLatitude: 0,
    nrLongitude: 0,
    nrLatitudeCidade: 0,
    nrLongitudeCidade: 0,
    dsNomeRua: '',
    nrNumeroCasa: '',
    dsComplemento: '',
    dsReferencia: '',
    idBairro: 0,
    dsBairro: '',
  });

  const handleToPage = (url: string) => {
    return navigate(url, { replace: true });
  };

  const handleChangeForm = (event: any) => {
    const { name } = event.target;
    const { value } = event.target;

    setDataAddress((field: any) => {
      return {
        ...field,
        [`${name}`]: value,
      };
    });
  };

  const handleListState = async () => {
    createloading(true);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.listState({
          nr_operacao: 13,
        });

      setStateList(result.data);
      setOpenModalSelectStateCity(true);

      createloading(false);
    } catch (error) {
      createloading(false);
      setOpenModalSelectStateCity(false);
      toast.error('Ocorreu um erro ao listar os estados');
    }
  };

  const handleListCity = async () => {
    setOpenModalSelectStateCity(true);
    try {
      createloading(true);

      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.listCityState({
          nr_operacao: 14,
          tpCidades: 1,
          idEstado: stateSelected,
        });

      setCityList(result.data);
      createloading(false);
    } catch (error) {
      setOpenModalSelectStateCity(false);
      createloading(false);

      toast.error('Ocorreu um erro ao listar os cidades');
    }
  };

  const handleListDestrict = async (idCidade: number) => {
    if (!idCidade) {
      setErrorInfo('Selecione a cidade primeiro');
      setOpenModalErrorInfo(true);
      return;
    }
    try {
      createloading(true);

      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.listCityDestrict({
          idUsuario: signData.data?.user?.idUsuario,
          nr_operacao: 6,
          idCidade,
        });

      setDestrictList(result.data?.bairros);
      setOpenModalSelectDistrict(true);

      createloading(false);
    } catch (error: any) {
      setOpenModalSelectDistrict(false);
      if (error.response.status === 401) {
        signData.signingOut({
          http_status: 401,
          location: 'createAddress',
          id_shop: '',
        });
        toast.info('Sua sessão expirou, por favor faça login novamente');
      } else {
        toast.error('Ocorreu um erro ao listar os bairros');
      }
    } finally {
      createloading(false);
    }
  };

  const handleSelectForm = (
    name: any,
    id: number,
    desName: string,
    value: string,
  ) => {
    if (desName === 'dsEstado') {
      setStateSelected(id);
    }
    setDataAddress((field: any) => {
      return {
        ...field,
        [`${name}`]: id,
        [`${desName}`]: value,
      };
    });
  };

  const handleSelectCidadeForm = (data: any) => {
    setDataAddress((field: any) => {
      return {
        ...field,
        idCidade: data.idCidade,
        dsCidade: data.dsCidade,
        nrLatitudeCidade: data.nrLatitude,
        nrLongitudeCidade: data.nrLongitude,
      };
    });
  };

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();

    if (!dataAddress.idUsuario) {
      setErrorInfo('Ocorreu um erro, tente novamente');
      setOpenModalErrorInfo(true);
      return;
    }
    if (!dataAddress.idCidade) {
      setErrorInfo('Selecione a cidade primeiro');
      setOpenModalErrorInfo(true);
      return;
    }
    if (!dataAddress.idBairro) {
      setErrorInfo('Selecione o bairro do endereço');
      setOpenModalErrorInfo(true);
      return;
    }

    if (!dataAddress.dsNomeRua) {
      setErrorInfo('Digite seu endereço');
      setOpenModalErrorInfo(true);
      return;
    }

    if (!dataAddress.nrNumeroCasa) {
      setErrorInfo('Digite seu o número da sua casa');
      setOpenModalErrorInfo(true);
      return;
    }
    if (!dataAddress.dsReferencia) {
      setErrorInfo('Informe uma referência para auxiliar o entregador');
      setOpenModalErrorInfo(true);
      return;
    }
    try {
      saveStorege('@mais/delivery/address/create/progress', dataAddress);

      if (params && id_shop) {
        handleToPage(`/dashboard/user/address/map/${params}/${id_shop}`);
        return;
      }

      if (String(getUser) === '1') {
        handleToPage('/dashboard/user/address/map?user=1');
        return;
      }
      handleToPage('/dashboard/user/address/map');
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu um erro ao cadastrar seu endereço, tente novamente');
    }
  };

  useEffect(() => {
    if (dataAddress.idCidade) {
      handleListDestrict(dataAddress.idCidade);
      setOpenModalSelectStateCity(false);
    }
  }, [dataAddress.idCidade]);

  useEffect(() => {
    if (dataAddress.idBairro) {
      setOpenModalSelectDistrict(false);
    }
  }, [dataAddress.idBairro]);

  useEffect(() => {
    if (!openModalSelectStateCity) {
      setCityList('');
      setStateSelected(0);
    }
  }, [openModalSelectStateCity]);

  useEffect(() => {
    handleListState();
  }, []);

  useEffect(() => {
    if (signData.data.user?.idUsuario) {
      setDataAddress((field: any) => {
        return {
          ...field,
          [`idUsuario`]: signData.data.user?.idUsuario,
        };
      });
    }
  }, [signData.data.user]);

  useEffect(() => {
    if (stateSelected) {
      setOpenModalSelectStateCity(false);
      handleListCity();
    }
  }, [stateSelected]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="address" />
      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        marginBottom="100px"
      >
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          className={classeStyle.gridForm}
        >
          <form onSubmit={handleSubmit} className={classeStyle.form}>
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>Cidade - UF</label>
              <Grid
                onClick={() => handleListState()}
                className={classeStyle.gridInputText}
              >
                {dataAddress.dsCidade}
              </Grid>
            </Grid>
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>Bairro</label>
              <Grid
                onClick={() => handleListDestrict(dataAddress.idCidade)}
                className={classeStyle.gridInputText}
              >
                {dataAddress.dsBairro}
              </Grid>
            </Grid>
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>Nome da Rua</label>
              <input
                type="text"
                className={classeStyle.inputText}
                name="dsNomeRua"
                onChange={handleChangeForm}
              />
            </Grid>

            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>Número</label>
              <input
                type="text"
                className={classeStyle.inputText}
                name="nrNumeroCasa"
                onChange={handleChangeForm}
              />
            </Grid>
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>Complemento</label>
              <input
                type="text"
                className={classeStyle.inputText}
                name="dsComplemento"
                onChange={handleChangeForm}
              />
            </Grid>
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>Referência</label>
              <input
                type="text"
                className={classeStyle.inputText}
                name="dsReferencia"
                onChange={handleChangeForm}
              />
            </Grid>
            <Button
              className={classeStyle.btnSubmit}
              type="submit"
              variant="contained"
            >
              Continuar <IconSave className={classeStyle.iconSave} />
            </Button>
          </form>
        </Grid>
      </Grid>
      <FooterMenuMain />

      <Modal
        open={openModalSelectStateCity}
        onClose={() => setOpenModalSelectStateCity(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          {stateList && (
            <Grid container item textAlign="center" justifyContent="center">
              {!cityList ? (
                <>
                  <Grid
                    container
                    item
                    textAlign="center"
                    justifyContent="center"
                    xs={12}
                    className={classeStyle.content}
                  >
                    <h3 className={classeStyle.title}>Selecione o Estado</h3>
                  </Grid>
                  <Grid
                    container
                    item
                    textAlign="center"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Box
                      sx={{
                        width: '100%',
                        height: 350,
                      }}
                    >
                      <List
                        sx={{
                          width: '100%',
                          bgcolor: 'background.paper',
                          position: 'relative',
                          overflow: 'auto',
                          maxHeight: 350,
                          '& ul': { padding: 0 },
                        }}
                        subheader={<li />}
                      >
                        {stateList.map((data: any) => (
                          <li key={`${data.idEstado}`}>
                            <ul>
                              <ListItem
                                onClick={() =>
                                  handleSelectForm(
                                    'idEstado',
                                    data.idEstado,
                                    'dsEstado',
                                    data.dsEstado,
                                  )
                                }
                                className={classeStyle.gridNameCity}
                              >
                                <ListItemText
                                  className={classeStyle.nameCity}
                                  primary={`${data.dsEstado} - ${data.nmExtenso}`}
                                />
                              </ListItem>
                            </ul>
                          </li>
                        ))}
                      </List>
                    </Box>
                  </Grid>
                </>
              ) : (
                cityList && (
                  <>
                    <Grid
                      container
                      item
                      textAlign="center"
                      justifyContent="center"
                      xs={12}
                      className={classeStyle.content}
                    >
                      <h3 className={classeStyle.title}>Selecione a Cidade</h3>
                    </Grid>
                    <Grid
                      container
                      item
                      textAlign="center"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Box
                        sx={{
                          width: '100%',
                          height: 350,
                        }}
                      >
                        <List
                          sx={{
                            width: '100%',
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: 350,
                            '& ul': { padding: 0 },
                          }}
                          subheader={<li />}
                        >
                          {cityList.map((data: any) => (
                            <li key={`${data.idCidade}`}>
                              <ul>
                                <ListItem
                                  onClick={() => handleSelectCidadeForm(data)}
                                  className={classeStyle.gridNameCity}
                                >
                                  <ListItemText
                                    className={classeStyle.nameCity}
                                    primary={`${data.dsCidade}`}
                                  />
                                </ListItem>
                              </ul>
                            </li>
                          ))}
                        </List>
                      </Box>
                    </Grid>
                  </>
                )
              )}
            </Grid>
          )}
        </Box>
      </Modal>
      <Modal
        open={openModalSelectDistrict}
        onClose={() => setOpenModalSelectDistrict(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          {destrictList && (
            <Grid container item textAlign="center" justifyContent="center">
              <Grid
                container
                item
                textAlign="center"
                justifyContent="center"
                xs={12}
                className={classeStyle.content}
              >
                <h3 className={classeStyle.title}>Selecione o Bairro</h3>
              </Grid>
              <Grid
                container
                item
                textAlign="center"
                justifyContent="center"
                alignItems="center"
              >
                <Box
                  sx={{
                    width: '100%',
                    height: 350,
                  }}
                >
                  <List
                    sx={{
                      width: '100%',
                      bgcolor: 'background.paper',
                      position: 'relative',
                      overflow: 'auto',
                      maxHeight: 350,
                      '& ul': { padding: 0 },
                    }}
                    subheader={<li />}
                  >
                    {destrictList.map((data: any) => (
                      <li key={`${data.idBairro}`}>
                        <ul>
                          <ListItem
                            onClick={() =>
                              handleSelectForm(
                                'idBairro',
                                data.idBairro,
                                'dsBairro',
                                data.dsBairro,
                              )
                            }
                            className={classeStyle.gridNameCity}
                          >
                            <ListItemText
                              className={classeStyle.nameCity}
                              primary={`${data.dsBairro} `}
                            />
                          </ListItem>
                        </ul>
                      </li>
                    ))}
                  </List>
                </Box>
              </Grid>
            </Grid>
          )}
        </Box>
      </Modal>
      <Modal
        open={openModalErrorInfo}
        onClose={() => setOpenModalErrorInfo(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModalInfo, height: '550px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
            >
              Atenção!
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              {errorInfo}
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnSubmit}
            onClick={() => setOpenModalErrorInfo(false)}
            variant="contained"
          >
            Ok
          </Button>
        </Box>
      </Modal>
    </Container>
  );
};

export default Address;
